document.addEventListener("DOMContentLoaded", function () {
  const videoBlocks = document.querySelectorAll(".wp-block-video");

  videoBlocks.forEach(function (block) {
    const video = block.querySelector("video");

    video.addEventListener("play", function () {
      block.classList.add("is-playing");
    });

    video.addEventListener("pause", function () {
      block.classList.remove("is-playing");
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // Select all video elements with the autoplay attribute
  const autoplayVideos = document.querySelectorAll("video[autoplay]");

  // Loop through each autoplay video element
  autoplayVideos.forEach((video) => {
    // Add playsinline and muted attributes
    video.setAttribute("playsinline", "");
    video.setAttribute("muted", "");

    // For better cross-browser compatibility, also set the properties
    video.playsInline = true;
    video.muted = true;
  });
});
